module.exports = __webpack_public_path__ + "img/page_head.76ed7375.png";